import Donate from './Donate';
import { useTranslation } from 'react-i18next';

function DonateHome() {
  const { t } = useTranslation();
  return (
    <section id="services" className="cat-bg3">
      <div className="container">
        <div className="section-heading text-center">
          <h2>{t('donatePage.title')}</h2>
        </div>
        <Donate />
      </div>
      {/* /container */}
    </section>
  );
}

export default DonateHome;
